module.exports = __webpack_public_path__ + "img/pazarcloud-essential.d104149c.jpg";